// src/utils/colorUtils.js
export const getNextColor = (index) => {
  const colors = [
    '#4285F4', // Google blue
    '#EA4335', // Google red
    '#FBBC05', // Google yellow
    '#34A853', // Google green
    '#8F00FF', // Violet
    '#FF6D01', // Orange
  ];
  
  return colors[index % colors.length];
};